import React from "react";
import { BuyOrPreorderOptions } from "src/utils/ajaxUtils";
import { CONTENT_TYPE } from "src/utils/asinUtils";

export type FailableResult = { success: boolean; reasonCode?: string; borrowLimit?: boolean, redirectUrl?: string; };
type FailableResultConsumer = (result: FailableResult) => void;
export const onSuccess = (f: FailableResultConsumer) => (result: FailableResult) => {
    if (result.success) {
        f(result);
    }
    return result;
};
export const onFailure = (f: FailableResultConsumer) => (result: FailableResult) => {
    if (!result.success) {
        f(result);
    }
    return result;
};

export interface AcquisitionManagerContextI {
    isBorrowed: (asin: string) => boolean;
    wasReturned: (asin: string) => boolean;
    isOwned: (asin: string) => boolean;
    isSampleOwned: (asin: string) => boolean;
    isCompanionOwned: (asin: string) => boolean;
    returnAsin: (asin: string) => void;
    redeemOfferByActionType: (asin: string, actionType: string, focusCallback?: VoidFunction) => Promise<FailableResult>;
    buyOrPreorder: (asin: string, options: BuyOrPreorderOptions) => Promise<FailableResult>;
    openBook: (params: OpenBookParams) => Promise<void>;
    isOpening: (asin?: string) => boolean;
    ownershipFetched: boolean;
    lastUpdateTimestamp: number;
}

const noOp = () => { /* NoOp */ };
const noOpBool = () => false;
const noOpAsync = async () => { return; };
const AcquisitionManagerContext = React.createContext<AcquisitionManagerContextI>({
    isBorrowed: noOpBool,
    wasReturned: noOpBool,
    isOwned: noOpBool,
    isSampleOwned: noOpBool,
    isCompanionOwned: noOpBool,
    returnAsin: noOp,
    redeemOfferByActionType: async () => ({ success: false, reasonCode: "default", borrowLimit: false }),
    buyOrPreorder: async () => ({ success: false, reasonCode: "default", borrowLimit: false }),
    openBook: noOpAsync,
    isOpening: noOpBool,
    ownershipFetched: false,
    lastUpdateTimestamp: 0,
});

export default AcquisitionManagerContext;
